import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import axios from "axios";
Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [createPersistedState()],
  state: {
    credentials: {
      id: null,
      name: null,
      email: null,
      data: null,
      active: false,
      admin: false,
      shoppingCartUser: [],
    },
    token: localStorage.getItem("token") || null,
    activeCategory: null,
    snackbar: {
      visible: false,
      text: null,
      timeout: 3000,
      multiline: false,
      color: null,
    },
  },
  getters: {
    loggedIn(state) {
      return state.credentials.active;
    },
    getCurrentCredentials(state) {
      return state.credentials;
    },
  },
  mutations: {
    login(state, data) {
      state.credentials.id = data.id;
      state.credentials.name = data.name;
      state.credentials.email = data.email;
      //state.credentials.img = data.img;
      // state.credentials.country_code = data.country_code;
      state.credentials.admin = data.admin;
      state.credentials.active = true;
      state.token = data.token;
    },
    logout(state) {
      state.credentials.id = null;
      state.credentials.name = null;
      state.credentials.email = null;
      state.credentials.active = false;
      state.token = null;
    },
    showSnackbar(state, payload) {
      state.snackbar.text = payload.text;
      state.snackbar.color = payload.color;
      state.snackbar.multiline = payload.text.length > 50 ? true : false;

      if (payload.multiline) {
        state.snackbar.multiline = payload.multiline;
      }

      if (payload.timeout) {
        state.snackbar.timeout = payload.timeout;
      }
      state.snackbar.visible = true;
      setTimeout(() => {
        this.commit("closeSnackbar", state);
      }, 3000);
    },
    closeSnackbar(state) {
      state.snackbar.visible = false;
      state.snackbar.multiline = false;
      state.snackbar.timeout = 3000;
      state.snackbar.text = null;
    },
  },
  actions: {
    addShoppingCart(context, product) {
      return new Promise((resolve, reject) => {
        context.state.credentials.shoppingCartUser.push(product);
        resolve("ok");
      });
    },
    deleteShoppingCart(context, product) {
      return new Promise((resolve, reject) => {
        let deleteIndex = context.state.credentials.shoppingCartUser.findIndex(
          (item) => item.product_id === product.product_id
        );
        context.state.credentials.shoppingCartUser.splice(deleteIndex, 1);
        resolve("ok");
      });
    },
    clearCart(context) {
      return new Promise((resolve, reject) => {
        context.state.credentials.shoppingCartUser = [];
        resolve("ok");
      });
    },
    updateCategory(context, product) {
      return new Promise((resolve, reject) => {
        context.state.activeCategory = product;
        resolve("ok");
      });
    },
    login(context, credentials) {
      return new Promise((resolve, reject) => {
        axios
          .post("/api/login", {
            email: credentials.email,
            password: credentials.password,
          })
          .then((response) => {
            if (response.data.status == "1") {
              const data = response.data;
              localStorage.setItem("token", data.token);

              axios.defaults.headers.common["Authorization"] =
                "Bearer " + data.token;
              context.commit("login", data);
              resolve(response);
            }

            if (response.data.status == "2") {
              resolve(response);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    register({ commit }, formData) {
      return new Promise((resolve, reject) => {
        axios
          .post("/api/register", formData)
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            let errors = error.response.data;
            const errorsArray = [];
            Object.keys(errors).forEach(function(err) {
              errorsArray.push(errors[err]);
            });
            reject({ errors: errorsArray.flat() });
          });
      });
    },
    logout({ commit }) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + this.state.token;
      if (this.getters.loggedIn) {
        return new Promise((resolve, reject) => {
          commit("logout");
          resolve("ok");
          delete axios.defaults.headers.common["Authorization"];
        });
      }
    },
  },
  modules: {},
});
